import { css, mediaQueries } from '@eti/styles';
import { Inline, Stack } from '@etg/wings';
import Skeleton from '../../../../../common/components/Skeleton';

const wrapperStyles = css`
  display: none;

  @media ${mediaQueries.large.up} {
    display: block;
    padding: 0 12px;
    width: 25%;
  }
`;

const filtersSkeletonBgColor = '#e5e5e5';

const filterSkeletonWrapperStyles = css`
  margin-block-end: 40px;
`;
const FiltersSkeleton = () => (
  <div className={wrapperStyles}>
    {[...Array(4)].map((_, index) => (
      <Stack className={filterSkeletonWrapperStyles} key={index}>
        <Skeleton.Box backgroundColor={filtersSkeletonBgColor} height={24} />
        <Skeleton.Box backgroundColor={filtersSkeletonBgColor} height={24} width={65} />
      </Stack>
    ))}
    {[...Array(4)].map((_, index) => (
      <Stack className={filterSkeletonWrapperStyles} key={index}>
        <Skeleton.Box backgroundColor={filtersSkeletonBgColor} height={24} />
        <Inline noWrap>
          <Skeleton.Box backgroundColor={filtersSkeletonBgColor} height={24} width={30} />
          <Skeleton.Box backgroundColor={filtersSkeletonBgColor} height={24} width={30} />
        </Inline>
        <Skeleton.Box backgroundColor={filtersSkeletonBgColor} height={24} />
      </Stack>
    ))}
  </div>
);

export default FiltersSkeleton;
